module.exports = __webpack_public_path__ + "static/img/swiper8.3cf8c7c6.png";